import { createBrowserClient } from "@supabase/auth-helpers-remix";
import type { Database } from "./types/supabase.types";

let cachedClient: ReturnType<typeof createBrowserClient<Database>> | null = null;
let cachedKey: string | null = null;

export const createSupabaseBrowserClient = (
  supabaseProject: string,
  supabaseKey: string
) => {
  const key = `${supabaseProject}|${supabaseKey}`;
  if (cachedClient && cachedKey === key) {
    return cachedClient;
  }
  cachedClient = createBrowserClient<Database>(supabaseProject, supabaseKey);
  cachedKey = key;
  return cachedClient;
};
